import { cx } from 'lib/cx'

export function Divider({ className }: { className?: string }) {
  return (
    <div
      className={cx(
        'border-gray-20 inline-block self-stretch border-l',
        className,
      )}
    />
  )
}
